import PropTypes from 'prop-types';

import styleSheet from './styles/scorePredictor.module.scss';

import { getImageUrl } from '../../helpers/images';

const styles = styleSheet.locals || {};

/**
 * Component for the sponsor
 *
 * @param {object} props poll option props
 * @param {object} props.scorePredictor poll option data
 * @param {boolean} props.isVisible - footer sponsor visible, to decrease complexity of main components
 * @returns {Function} <Sponsor />
 */
function Sponsor({ scorePredictor, isVisible = true }) {
    const hasSponsorImg =
        scorePredictor.sponsor_image_url ||
        scorePredictor.sponsor_external_image_url;

    if (!hasSponsorImg || !isVisible) {
        return null;
    }
    /* eslint-disable no-magic-numbers */

    const sponsorUrl = scorePredictor?.sponsor_url;

    const isValidUrl = (url) => {
        try {
            new URL(url);
            return true;
            /* eslint-disable-next-line id-length */
        } catch (_) {
            return false;
        }
    };

    const validUrl = isValidUrl(sponsorUrl);

    const renderSponsorImage = () => {
        if (scorePredictor.sponsor_image_url) {
            return (
                <img
                    part="score-predictor-sponsor-image"
                    src={getImageUrl(scorePredictor.sponsor_image_url, 160)}
                    alt={scorePredictor.sponsor_image_text || ''}
                    className={styles.scorePredictorSponsorImage}
                    data-testid={'sponsor-image-manual'}
                />
            );
        }

        if (scorePredictor.sponsor_external_image_url) {
            return (
                <img
                    part="score-predictor-sponsor-image"
                    src={scorePredictor.sponsor_external_image_url}
                    alt={scorePredictor.sponsor_image_text || ''}
                    className={styles.scorePredictorSponsorImage}
                    data-testid={'sponsor-image-automated'}
                />
            );
        }

        return null;
    };

    return (
        <div
            data-cy="sponsorLabel"
            part="score-predictor-sponsor"
            className={styles.scorePredictorSponsor}
            data-testid="predictor-sponsor"
        >
            {scorePredictor.sponsor_label ? (
                <div
                    part="score-predictor-sponsor-label"
                    className={styles.scorePredictorSponsorLabel}
                >
                    {scorePredictor.sponsor_label}
                </div>
            ) : (
                ''
            )}

            {validUrl ? (
                <a href={sponsorUrl} target="_blank" rel="noopener noreferrer">
                    {renderSponsorImage()}
                </a>
            ) : (
                renderSponsorImage()
            )}
        </div>
    );
}

Sponsor.propTypes = {
    scorePredictor: PropTypes.object.isRequired,
    isVisible: PropTypes.bool
};

export default Sponsor;
